export const experimentData = {
  data() {
    return {
      circuit: [
        {
          id: 1,
          subject: '전원 공급기와 멀티미터 기능과 사용법을 익히고 저항소자를 사용하여 전기회로의 기본법칙인 Ohm의 법칙 및 Kirchhoff의 법칙 이해.',
          title: '전원공급기와 멀티미터 사용법',
          introduction: require('../../assets/images/circuit/introduction/ex1.jpg'),
          img: require('../../assets/images/circuit/slide/powersupply.svg'),
          simul: require('../../assets/images/circuit/simul/ex2.png'),
          link: '/ex1',
          show: false
        },
        {
          id: 2,
          subject: '중첩의 원리를 이해하고, 직류전원으로부터 부하에 최대 전력을 공급할 수 있는 조건을 결정하는 최대전력  전달 이론 이해.',
          title: '중첩의 원리 및 최대 전력 전달 원리',
          introduction: require('../../assets/images/circuit/introduction/ex2.jpg'),
          img: require('../../assets/images/circuit/slide/resistor.svg'),
          link: '/ex2',
          show: false
        },
        {
          id: 3,
          subject: '함수발생기와 오실로스코프의 사용법을 익히고 입력전압, 주파수, 파형 및 각종 조절 스위치의 작동법을 이해.',
          title: '함수발생기, 오실로스코프 사용법',
          introduction: require('../../assets/images/circuit/introduction/ex3.jpg'),
          img: require('../../assets/images/circuit/slide/oscilloscope.svg'),
          link: '/ex4',
          show: false
        },
        {
          id: 4,
          subject: '아날로그 회로에서 자주 쓰이는 에너지 저장소 인덕터와 콘덴서의 특징을 이해하고 R-C 회로와 R-L-C 회로를 구성하여 과도응답, 정상상태응답 및 필터링 개념 이해.',
          title: '인덕터와 콘덴서의 특징 및 R-L-C 회로특성',
          introduction: require('../../assets/images/circuit/introduction/ex4.jpg'),
          img: require('../../assets/images/circuit/slide/inductor.svg'),
          link: '/ex5',
          show: false
        },
        {
          id: 5,
          subject: '정류의 목적으로 만들어진 접합 다이오드, 제너 다이오드의 동작 특성 및 전압에 대한 전류 특성을 관찰하고, 광소자로서 LED, 7-segment 등의 표시기에 대해 이해.',
          title: '다이오드 및 광소자의 특성',
          introduction: require('../../assets/images/circuit/introduction/ex5.jpg'),
          img: require('../../assets/images/circuit/slide/sevensegment.svg'),
          link: '/ex7',
          show: false
        },
        {
          id: 6,
          subject: '다이오드를 이용한 응용실험으로 교류신호를 직류신호로 바꾸는 과정인 정류과정을 이해하고, 반파/전파 및 브리지 정류회를 각각 구성하여 입/출력 파형을 관찰함으로써 교류신호로부터 직류신호의 정류과정을 이해.',
          title: '다이오드 반파/전파 및 브리지 정류회로',
          introduction: require('../../assets/images/circuit/introduction/ex5.jpg'),
          img: require('../../assets/images/circuit/slide/bridgediode.svg'),
          link: '/ex8',
          show: false
        },
        {
          id: 7,
          subject: '아날로그회로에서 많이 쓰이는 전기소자인 트랜지스터 및 릴레이의 특성을 이해하고 트랜지스터를 이용하여 OP-amp를 구동해본다.',
          title: '트랜지스터의 특성 및 해석',
          introduction: require('../../assets/images/circuit/introduction/ex7.jpg'),
          img: require('../../assets/images/circuit/slide/relay.svg'),
          link: '/ex10',
          show: false
        },
        {
          id: 8,
          subject: '연산증폭기의 특성 및 사용법을 이해하고 연산증폭기를 이용한 응용으로 아날로그 신호의 증폭 방법을 이해.',
          title: '연산증폭기의 원리 및 특성',
          introduction: require('../../assets/images/circuit/introduction/ex8.jpg'),
          img: require('../../assets/images/circuit/slide/opamp.svg'),
          link: '/ex13',
          show: false
        },
        {
          id: 9,
          subject: '연산증폭기를 이용한 응용으로 적분기, 미분기, 저역/고역 통과 필터 회로의 구성 및 실험을 통해 아날로그 신호의 적분신호, 미분신호, 저역/고역 통과 필터의 특성을 이해.',
          title: '연산증폭기를 이용한 응용 회로',
          introduction: require('../../assets/images/circuit/introduction/ex9.jpg'),
          img: require('../../assets/images/circuit/slide/functiongen.svg'),
          link: '/ex14',
          show: false
        },
        {
          id: 10,
          subject: '디지털 회로의 기본적인 스위칭 동작과 안정성을 이해하고 디지털 회로의 기본적인 논리회로인 AND, OR, NOT, NAND, NOR, XOR 게이트의 입출력 특성을 알아보고 이 특성을 이용하여 간단한 논리 회로를 설계.',
          title: '디지털 논리 회로',
          introduction: require('../../assets/images/circuit/introduction/ex10.jpg'),
          img: require('../../assets/images/circuit/slide/IC(8pins).svg'),
          link: '/ex16',
          show: false
        },
        {
          id: 11,
          subject: '각종 논리 연산에서 래치(latch), 메모리의 필요성을 이해하고, 래치구조를 이용한 여러 가지 논리 회로의 구성과 동작, 그리고 그 응용에 대해 실습.',
          title: '플립플롭의 특성 및 응용',
          introduction: require('../../assets/images/circuit/introduction/ex11.jpg'),
          img: require('../../assets/images/circuit/slide/counter.svg'),
          link: '/ex18',
          show: false
        },
        {
          id: 12,
          subject: 'PID제어기를 설계하고 실험을 통해 서보모터의 위치를 제어해 봄으로써 각 제어 게인의 기능을 이해한다.',
          title: 'PID 제어기를 이용한 서보모터 위치 제어',
          introduction: require('../../assets/images/motor/introduction/ex1.png'),
          img: require('../../assets/images/circuit/slide/acmotor.svg'),
          link: '/',
          show: false
        }
      ],
      moduleCom: [
        {
          id: 1,
          title: '통합실험',
          subject: '모든 장비 및 부품을 모듈화하여 자유로운 실험이 가능해서 활용도가 높은 반면, 초보자가 실험에 대한 이해없이 사용하기는 다소 어려울 수 있습니다.',
          introduction: require('../../assets/images/micom/introduction/ex4.png'),
          img: require('../../assets/images/micom/slide/dc-motor.svg'),
          // use: ['브레드보드', '아두이노R3 우노', '빨간색 LED', '저항', '조도 센서', '압력 센서', '온도 센서', '온습도 센서', '초음파 센서', '적외선 센서', '조이스틱', '프로브',
          //   '가속도 센서', '트랜지스터', 'DC 모터', '미니 서보 모터', '택트 스위치', '딥 스위치', '인체감지 센서', '릴레이 모듈', 'LCD', '유니폴라 스텝모터', '모터드라이버', '전원공급기', '멀티미터', '함수발생기', '오실로스코프',
          //   '다이오드', '인덕터', '콘덴서', '가변저항']
          use: ['브레드보드', '전원공급기', '멀티미터', '함수발생기', '오실로스코프', '프로브',
            '저항', '다이오드', '인덕터', '콘덴서', '가변저항', '트랜지스터', '택트 스위치', '딥 스위치',
            '빨간색 LED', '조도 센서', '압력 센서', '온도 센서', 
            // '온습도 센서', '초음파 센서', '적외선 센서', '조이스틱', 
            // '가속도 센서', 'DC 모터', '미니 서보 모터', '인체감지 센서', '릴레이 모듈', 'LCD', '유니폴라 스텝모터', '모터드라이버',
          ]
        }
      ],
      micom: [
        {
          id: 1,
          title: '디지털 출력',
          subject: '디지털 출력 핀을 통해서 LED 점등, 릴레이 구동, 스텝모터 제어, 모터 ON/OFF 제어해 봄으로써 디지털 출력의 원리를 이해한다.',
          img: require('../../assets/images/micom/slide/relay.svg'),
          introduction: require('../../assets/images/micom/introduction/ex1.jpg'),
          tutorial: require('../../assets/images/micom/tutorial/ex1.mp4'),
          simul: [],
          use: ['브레드보드', '아두이노R3 우노', '빨간색 Led', '저항', '릴레이 모듈', 'LCD', '택트 스위치', '딥 스위치', '인체감지 센서', '유니폴라 스텝모터']
        },
        {
          id: 2,
          title: '디지털 입력',
          subject: '디지털 입력 핀을 통해서 푸시버튼, 택트 스위치, 딥 스위치와 같은 간단히 스위치 입력 상태를 읽어 봄으로써 디지털 입력의 원리를 이해한다.',
          img: require('../../assets/images/micom/slide/dip-switch.svg'),
          introduction: require('../../assets/images/micom/introduction/ex2.png'),
          simul: [],
          use: ['브레드보드', '아두이노R3 우노', '빨간색 Led', '저항', '택트 스위치', '딥 스위치', '인체감지 센서', '릴레이 모듈', 'LCD', '유니폴라 스텝모터']
        },
        {
          id: 3,
          title: '아날로그 입력',
          subject: '아날로그 입력 핀을 통해서 온도, 습도, 압력, 가속도, 적외선 센서 통해 연속된 신호를 처리해 봄으로써 아날로그 입력의 원리를 이해한다.',
          introduction: require('../../assets/images/micom/introduction/ex3.png'),
          img: require('../../assets/images/micom/slide/dht11.svg'),
          use: ['브레드보드', '아두이노R3 우노', '빨간색 Led', '저항', '트랜지스터', 'DC 모터', '미니 서보 모터', '조도 센서', '압력 센서', '온도 센서', '온습도 센서', '초음파 센서', '적외선 센서', '조이스틱', '가속도 센서']
        },
        {
          id: 4,
          title: '아날로그 출력',
          subject: '아날로그 출력 핀을 통해서 LED 밝기제어, 모터 속도제어, RC서보모터 위치를 제어해 봄으로써 아날로그 출력의 원리를 이해한다.',
          introduction: require('../../assets/images/micom/introduction/ex4.png'),
          img: require('../../assets/images/micom/slide/servo-motor.svg'),
          use: ['브레드보드', '아두이노R3 우노', '빨간색 Led', '저항', '조도 센서', '압력 센서', '온도 센서', '온습도 센서', '초음파 센서', '적외선 센서', '조이스틱', '가속도 센서', '트랜지스터', 'DC 모터', '미니 서보 모터']
        },
        {
          id: 5,
          title: '통합실험',
          subject: '아날로그와 디지털 입출력을 함께 사용하여 종합적인 컴퓨터 인터페이싱 설계를 할 수 있다.',
          introduction: require('../../assets/images/micom/introduction/ex4.png'),
          img: require('../../assets/images/micom/slide/dc-motor.svg'),
          use: ['브레드보드', '아두이노R3 우노', '빨간색 LED', '저항', '조도 센서', '압력 센서', '온도 센서', '온습도 센서', '초음파 센서', '적외선 센서', '조이스틱', '프로브',
            '가속도 센서', '트랜지스터', 'DC 모터', '미니 서보 모터', '택트 스위치', '딥 스위치', '인체감지 센서', '릴레이 모듈', 'LCD', '유니폴라 스텝모터', '모터드라이버', '전원공급기', '멀티미터', '함수발생기', '오실로스코프',
            '다이오드', '인덕터', '콘덴서', '가변저항']
        }
      ],
      motor: [
        {
          id: 1,
          subject: 'PID제어기를 설계하고 실험을 통해 서보모터의 위치를 제어해 봄으로써 각 제어 게인의 기능을 이해한다.',
          title: 'PID 제어기를 이용한 서보모터 위치 제어',
          introduction: require('../../assets/images/motor/introduction/ex1.png'),
          img: require('../../assets/images/circuit/slide/acmotor.svg'),
          link: '/',
          show: true
        },
        {
          id: 2,
          subject: '보상기를 설계하고 보상기의 영점과 극점의 위치를 바꿔어 보면서 서보모터의 위치를 제어해 봄으로써 보상기의 영점과 극점이 서보모터의 위치 제어 성능에 미치는 영향을 이해한다.',
          title: '앞섬/뒤짐 제어기를 이용한 서보모터 위치 제어',
          introduction: require('../../assets/images/circuit/introduction/ex8.jpg'),
          img: require('../../assets/images/circuit/slide/acmotor-waiting.svg'),
          link: '/',
          show: false
        },
        {
          id: 3,
          subject: '감쇠비와 고유주파수의 변화에 따른 극점의 위치를 이동하면서 서보모터의 위치를 제어해 봄으로써 극점배치기법의 원리를 이해한다.',
          title: '극점배치기법을 이용한 서보모터 위치 제어',
          introduction: require('../../assets/images/circuit/introduction/ex8.jpg'),
          img: require('../../assets/images/circuit/slide/acmotor-waiting.svg'),
          link: '/',
          show: false
        }
      ]
    }
  }
}
